
export const landingPageConfig = {
  appMeta: {
    appName: "LearnZapp",
    baseUrl: "https://comptia.learnzapp.com",
    productLine: "CompTIA",
    publisher: "Wiley",
    hubTitle: "CompTIA Certification Exam Prep | 12 Certs Powered by Wiley - LearnZapp",
    hubDescription: "Prepare for 12 CompTIA certifications with practice questions from Wiley. Security+, A+, Network+ and more. Adaptive learning, detailed analytics, and expert-crafted content.",
    hubMetaTitle: "CompTIA Certification Exam Prep | 12 Certs Powered by Wiley",
    hubMetaDescription: "Prepare for 12 CompTIA certifications with practice questions from Wiley. Security+, A+, Network+ and more.",
    utmCampaign: "comptia-launch",
    ogImage: "/assets/images/og-image.png"
  },

  certSlugs: {
    a_220_1201: "a-plus-core-1",
    a_220_1202: "a-plus-core-2",
    cloud_cv0_004: "cloud-plus",
    cysa_cs0_003: "cysa-plus",
    datasys_ds0_001: "datasys-plus",
    datax_dx0_001: "datax",
    linux_xk0_006: "linux-plus",
    network_n10_009: "network-plus",
    pentest_pt0_003: "pentest-plus",
    project_pk0_005: "project-plus",
    security_sy0_701: "security-plus",
    server_sk0_005: "server-plus"
  },

  certMeta: {
    a_220_1201: {
      pageTitle: "CompTIA A+ 220-1201 (Core 1) Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "Comprehensive A+ Core 1 220-1201 practice questions from Wiley. Mobile devices, networking, hardware, virtualization & cloud computing.",
      h1: "CompTIA A+ 220-1201 (Core 1) Exam Prep"
    },
    a_220_1202: {
      pageTitle: "CompTIA A+ 220-1202 (Core 2) Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "Comprehensive A+ Core 2 220-1202 practice questions from Wiley. Operating systems, security, software troubleshooting & operational procedures.",
      h1: "CompTIA A+ 220-1202 (Core 2) Exam Prep"
    },
    cloud_cv0_004: {
      pageTitle: "CompTIA Cloud+ CV0-004 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "Cloud+ CV0-004 practice questions from Wiley. Cloud architecture, security, deployment, operations & troubleshooting.",
      h1: "CompTIA Cloud+ CV0-004 Exam Prep"
    },
    cysa_cs0_003: {
      pageTitle: "CompTIA CySA+ CS0-003 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "CySA+ CS0-003 practice questions from Wiley. Security operations, vulnerability management, incident response & reporting.",
      h1: "CompTIA CySA+ CS0-003 Exam Prep"
    },
    datasys_ds0_001: {
      pageTitle: "CompTIA DataSys+ DS0-001 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "DataSys+ DS0-001 practice questions from Wiley. Database fundamentals, deployment, management & troubleshooting.",
      h1: "CompTIA DataSys+ DS0-001 Exam Prep"
    },
    datax_dx0_001: {
      pageTitle: "CompTIA DataX DX0-001 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "DataX DX0-001 practice questions from Wiley. Data science, machine learning, AI concepts & data governance.",
      h1: "CompTIA DataX DX0-001 Exam Prep"
    },
    linux_xk0_006: {
      pageTitle: "CompTIA Linux+ XK0-006 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "Linux+ XK0-006 practice questions from Wiley. System management, security, scripting, containers & troubleshooting.",
      h1: "CompTIA Linux+ XK0-006 Exam Prep"
    },
    network_n10_009: {
      pageTitle: "CompTIA Network+ N10-009 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "Network+ N10-009 practice questions from Wiley. Networking fundamentals, implementations, operations, security & troubleshooting.",
      h1: "CompTIA Network+ N10-009 Exam Prep"
    },
    pentest_pt0_003: {
      pageTitle: "CompTIA PenTest+ PT0-003 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "PenTest+ PT0-003 practice questions from Wiley. Planning, information gathering, attacks, reporting & tools.",
      h1: "CompTIA PenTest+ PT0-003 Exam Prep"
    },
    project_pk0_005: {
      pageTitle: "CompTIA Project+ PK0-005 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "Project+ PK0-005 practice questions from Wiley. Project management basics, constraints, communication & change management.",
      h1: "CompTIA Project+ PK0-005 Exam Prep"
    },
    security_sy0_701: {
      pageTitle: "CompTIA Security+ SY0-701 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "500+ Security+ SY0-701 practice questions from Wiley. General security concepts, threats, architecture, operations & program management.",
      h1: "CompTIA Security+ SY0-701 Exam Prep"
    },
    server_sk0_005: {
      pageTitle: "CompTIA Server+ SK0-005 Practice Test | Wiley Questions - LearnZapp",
      metaDescription: "Server+ SK0-005 practice questions from Wiley. Server hardware, administration, security, storage & troubleshooting.",
      h1: "CompTIA Server+ SK0-005 Exam Prep"
    }
  },

  certFaqs: {
    a_220_1201: [
      { question: "How many questions are on the CompTIA A+ 220-1201 exam?", answer: "The A+ 220-1201 (Core 1) exam has a maximum of 90 questions, including multiple-choice and performance-based questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for A+ Core 1?", answer: "The passing score for the A+ 220-1201 exam is 675 on a scale of 100-900." },
      { question: "What topics does A+ Core 1 cover?", answer: "Core 1 covers mobile devices, networking, hardware, virtualization & cloud computing, and hardware & network troubleshooting." },
      { question: "Is CompTIA A+ worth it in 2025?", answer: "Yes, CompTIA A+ remains one of the most recognized entry-level IT certifications. It validates foundational IT skills and is often required for help desk, desktop support, and field technician roles." }
    ],
    a_220_1202: [
      { question: "How many questions are on the CompTIA A+ 220-1202 exam?", answer: "The A+ 220-1202 (Core 2) exam has a maximum of 90 questions, including multiple-choice and performance-based questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for A+ Core 2?", answer: "The passing score for the A+ 220-1202 exam is 700 on a scale of 100-900." },
      { question: "What topics does A+ Core 2 cover?", answer: "Core 2 covers operating systems, security, software troubleshooting, and operational procedures." },
      { question: "Do I need to pass both A+ exams?", answer: "Yes, you must pass both the 220-1201 (Core 1) and 220-1202 (Core 2) exams to earn the CompTIA A+ certification." }
    ],
    cloud_cv0_004: [
      { question: "How many questions are on the Cloud+ exam?", answer: "The Cloud+ CV0-004 exam has a maximum of 90 questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for Cloud+?", answer: "The passing score for Cloud+ CV0-004 is 750 on a scale of 100-900." },
      { question: "What topics does Cloud+ cover?", answer: "Cloud+ covers cloud architecture and design, security, deployment, operations and support, and troubleshooting." },
      { question: "Is Cloud+ harder than A+?", answer: "Yes, Cloud+ is an intermediate-level certification that assumes foundational IT knowledge. CompTIA recommends Network+ and Server+ certifications or equivalent experience before attempting Cloud+." }
    ],
    cysa_cs0_003: [
      { question: "How many questions are on the CySA+ exam?", answer: "The CySA+ CS0-003 exam has a maximum of 85 questions, including multiple-choice and performance-based questions. You have 165 minutes to complete it." },
      { question: "What is the passing score for CySA+?", answer: "The passing score for CySA+ CS0-003 is 750 on a scale of 100-900." },
      { question: "What topics does CySA+ cover?", answer: "CySA+ covers security operations, vulnerability management, incident response and management, and reporting and communication." },
      { question: "Is CySA+ good for cybersecurity careers?", answer: "Yes, CySA+ is an intermediate-level cybersecurity certification that validates threat detection and response skills. It's ideal for security analysts and SOC roles." }
    ],
    datasys_ds0_001: [
      { question: "How many questions are on the DataSys+ exam?", answer: "The DataSys+ DS0-001 exam has a maximum of 90 questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for DataSys+?", answer: "The passing score for DataSys+ DS0-001 is 720 on a scale of 100-900." },
      { question: "What topics does DataSys+ cover?", answer: "DataSys+ covers database fundamentals, database deployment, database management and maintenance, data and database security, and business continuity." },
      { question: "Who should take DataSys+?", answer: "DataSys+ is designed for database administrators and data professionals who manage and maintain databases. It validates skills in database deployment, management, and security." }
    ],
    datax_dx0_001: [
      { question: "How many questions are on the DataX exam?", answer: "The DataX DX0-001 exam has a maximum of 90 questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for DataX?", answer: "The passing score for DataX DX0-001 is 720 on a scale of 100-900." },
      { question: "What topics does DataX cover?", answer: "DataX covers data environments, exploratory data analysis, data management, machine learning, artificial intelligence, and data governance." },
      { question: "Is DataX a new CompTIA certification?", answer: "Yes, DataX is one of CompTIA's newer certifications focused on data science, AI, and machine learning skills that are increasingly in demand across industries." }
    ],
    linux_xk0_006: [
      { question: "How many questions are on the Linux+ exam?", answer: "The Linux+ XK0-006 exam has a maximum of 90 questions, including multiple-choice and performance-based questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for Linux+?", answer: "The passing score for Linux+ XK0-006 is 720 on a scale of 100-900." },
      { question: "What topics does Linux+ cover?", answer: "Linux+ covers system management, security, scripting, containers, automation, and troubleshooting." },
      { question: "Is Linux+ worth it?", answer: "Yes, Linux+ validates essential Linux administration skills. It's vendor-neutral and recognized globally, making it valuable for system administrators and DevOps engineers." }
    ],
    network_n10_009: [
      { question: "How many questions are on the Network+ exam?", answer: "The Network+ N10-009 exam has a maximum of 90 questions, including multiple-choice and performance-based questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for Network+?", answer: "The passing score for Network+ N10-009 is 720 on a scale of 100-900." },
      { question: "What topics does Network+ cover?", answer: "Network+ covers networking fundamentals, network implementations, network operations, network security, and network troubleshooting." },
      { question: "Should I get Network+ before Security+?", answer: "CompTIA recommends Network+ before Security+ as it provides the networking foundation that Security+ builds upon. However, it's not a strict prerequisite." }
    ],
    pentest_pt0_003: [
      { question: "How many questions are on the PenTest+ exam?", answer: "The PenTest+ PT0-003 exam has a maximum of 85 questions, including multiple-choice and performance-based questions. You have 165 minutes to complete it." },
      { question: "What is the passing score for PenTest+?", answer: "The passing score for PenTest+ PT0-003 is 750 on a scale of 100-900." },
      { question: "What topics does PenTest+ cover?", answer: "PenTest+ covers planning and scoping, information gathering, attacks and exploits, reporting and communication, and tools and code analysis." },
      { question: "Is PenTest+ harder than Security+?", answer: "Yes, PenTest+ is a more advanced certification focused on offensive security. CompTIA recommends Security+ and at least 3-4 years of hands-on experience before attempting PenTest+." }
    ],
    project_pk0_005: [
      { question: "How many questions are on the Project+ exam?", answer: "The Project+ PK0-005 exam has a maximum of 95 questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for Project+?", answer: "The passing score for Project+ PK0-005 is 710 on a scale of 100-900." },
      { question: "What topics does Project+ cover?", answer: "Project+ covers project management concepts, project life cycle phases, tools and documentation, communication and change management, and agile/waterfall methodologies." },
      { question: "How does Project+ compare to PMP?", answer: "Project+ is an entry-level project management certification, while PMP is more advanced. Project+ doesn't require prior project management experience, making it ideal for those starting their PM career." }
    ],
    security_sy0_701: [
      { question: "How many questions are on the Security+ exam?", answer: "The Security+ SY0-701 exam has a maximum of 90 questions, including multiple-choice and performance-based questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for Security+?", answer: "The passing score for Security+ SY0-701 is 750 on a scale of 100-900." },
      { question: "What topics does Security+ SY0-701 cover?", answer: "Security+ covers general security concepts, threats vulnerabilities and mitigations, security architecture, security operations, and security program management and oversight." },
      { question: "Is Security+ DoD approved?", answer: "Yes, CompTIA Security+ meets the DoD 8570/8140 requirements for IAT Level II, IAM Level I, and IASAE Level I positions, making it essential for many government and defense IT roles." },
      { question: "How hard is the Security+ exam?", answer: "Security+ is considered moderately difficult. CompTIA recommends having Network+ and two years of IT experience with a security focus. With proper preparation using practice questions, most candidates pass on their first attempt." }
    ],
    server_sk0_005: [
      { question: "How many questions are on the Server+ exam?", answer: "The Server+ SK0-005 exam has a maximum of 90 questions. You have 90 minutes to complete it." },
      { question: "What is the passing score for Server+?", answer: "The passing score for Server+ SK0-005 is 750 on a scale of 100-900." },
      { question: "What topics does Server+ cover?", answer: "Server+ covers server hardware, server administration, security, storage, and troubleshooting." },
      { question: "Who should take Server+?", answer: "Server+ is designed for IT professionals who install, manage, and troubleshoot servers in data centers and on-premises/hybrid environments. It's ideal for server administrators and data center technicians." }
    ]
  },

  appConfig: {

    logo: '/assets/images/logo.png',

    breadcrumb: [
      { label: 'Home', url: 'https://www.learnzapp.com' },
      { label: 'CompTIA Certifications' }
    ],
    navItems: [
      { label: 'Home', url: '#home' },
      { label: 'Download', url: '#download' },
      { label: 'Features', url: '#features' },
      { label: 'Screenshots', url: '#screenshots' },
      { label: 'Pricing', url: '#pricing' }
    ],
    hero: {
      title: 'Master CompTIA Certifications',
      subtitle1: 'Comprehensive exam preparation for 12 CompTIA certifications with adaptive learning, detailed analytics, and expert-crafted content.',
      subtitle2: 'Start studying smarter today.',
      stats: [
        { value: '10K+', label: 'Active Users', icon:'users'},
        { value: '95%', label: 'Pass Rate', icon:'trophy' },
        { value: '10000+', label: 'Practice Questions', icon:'question-circle' }
      ],
      appIcon: '/assets/images/app-icon.png',
      heroImage: '/assets/images/hero-image.png',
      heroImageDark: '/assets/images/hero-image-dark.png',

    },
    studyAnywhere: {
      title: 'Study Anywhere',
      subtitle: 'Your progress syncs across all your devices - phones, tablets, and web. Start studying on your phone during your commute and continue on your laptop browser at home.',
    },

    downloadLinks: [
      {
        store: 'Apple',
        title: 'App Store',
        url: '#'
      },
      {
        store: 'Google',
        title: 'Google Play',
        url: '#'
      }
    ]
  },

  featuresData: {
    title: 'Everything You Need to Succeed',
    subtitle: 'Comprehensive study tools designed specifically for CompTIA certification success',

      "items": [
        {
          "icon": "chart-line",
          "title": "Readiness Score Analytics",
          "description": "Track your overall readiness and domain-specific performance with detailed analytics. See exactly where you stand and what to focus on next."
        },
        {
          "icon": "file-text",
          "title": "Study Articles & Questions",
          "description": "Expert-written articles covering key exam topics with mapped practice questions. Study the concept, then test your understanding immediately.",

        },
        {
          "icon": "tools",
          "title": "Custom Test Builder",
          "description": "Create personalized practice tests by selecting specific domains, difficulty levels, and question counts. Study exactly what you need."
        },
        {
          "icon": "calendar-day",
          "title": "Question of the Day",
          "description": "Build your study streak with daily questions. Track your progress and maintain momentum with just 2 minutes a day.",

        },
        {
          "icon": "users",
          "title": "Community Insights",
          "description": "See how other exam candidates answered each question. Learn from the community and understand common mistakes."
        },
        {
          "icon": "sync",
          "title": "Seamless Sync",
          "description": "Study on web, iOS, or Android. Your progress syncs automatically across all devices. Pick up exactly where you left off."
        },
        {
          "icon": "book",
          "title": "Comprehensive Resources",
          "description": "Flashcards, glossary, acronyms, and study guides. Everything you need in one place with regular content updates."
        },
        {
          "icon": "moon",
          "title": "Adaptive Interface",
          "description": "Dark/light mode support and responsive design. Study comfortably any time of day on any device."
        }
      ]

  },
  platforms: [
    {
      icon: 'laptop',
      title: 'Web Platform',
      description: 'Full-featured experience in your browser. Perfect for focused study sessions with detailed analytics.',
      ctaText: 'Sign In to Web App',
      ctaLink: 'https://comptia.learnzapp.com',
    },
    {
      icon: 'mobile-alt',
      title: 'Mobile Apps',
      description: 'Study on-the-go with native iOS and Android apps. Download for offline access and push notifications.',
      ctaText: 'Download Mobile App',
      ctaLink: '#downloads',
    },
    {
      icon: 'bullseye',
      title: 'Diagnostic Test',
      description: 'Not sure where to start? Take our free diagnostic test to assess your current knowledge and get a personalized study plan.',
      ctaText: 'Take Diagnostic Test',
      ctaLink: '#diagnostic',
    },
  ],

  screenshotsData: {
    title: "See It In Action",
    subtitle: "Explore our app's powerful features through these interactive screenshots",
    slides: [
      {
        "id": 1,
        "title": "Home Dashboard for Quick Access",
        "description": "Start studying instantly from the home screen with quick links to questions, tests, flashcards, and custom test creation.",
        "features": [
          "Overall readiness overview",
          "Daily question prompt",
          "Quick access to key study modes"
        ],
        "image": "/assets/images/screenshots/1.png"
      },
      {
        "id": 2,
        "title": "Light & Dark Mode Support",
        "description": "Choose between light and dark themes for comfortable studying in any environment.",
        "features": [
          "Easy theme switching",
          "Eye-friendly design",
          "Optimized for different lighting conditions"
        ],

        "image": "/assets/images/screenshots/2.png"
      },
      {
        "id": 3,
        "title": "Monitor Overall Exam Readiness",
        "description": "View your readiness score across all topics with detailed breakdowns to target weak areas.",
        "features": [
          "Overall readiness score gauge",
          "Topic-wise readiness percentages",
          "Performance history tracking"
        ],
        "image": "/assets/images/screenshots/3.png"
      },
      {
        "id": 4,
        "title": "Create Custom Practice Tests",
        "description": "Build tests tailored to your needs by topic, question count, time limit, and priority type.",
        "features": [
          "Select topics and number of questions",
          "Set time limits",
          "Prioritize incorrect, new, or bookmarked questions"
        ],
        "image": "/assets/images/screenshots/4.png"
      },
      {
        "id": 5,
        "title": "Answer with Confidence",
        "description": "Tackle multiple-choice questions in a clean, distraction-free interface for better focus and accuracy.",
        "features": [
          "Clear question and answer layout",
          "Multiple-choice options",
          "Timer to track pacing"
        ],
        "image": "/assets/images/screenshots/5.png"
      },
      {
        "id": 6,
        "title": "Track Progress in Each Test",
        "description": "Get instant feedback on your performance after each test with accuracy, time per question, and readiness score updates.",
        "features": [
          "Test score and accuracy breakdown",
          "Average time per question",
          "Readiness score improvement tracking"
        ],
        "image": "/assets/images/screenshots/6.png"
      },
      {
        "id": 7,
        "title": "Detailed Answer Explanations",
        "description": "Understand the reasoning behind correct answers with clear, concise explanations after each question.",
        "features": [
          "Highlights correct and incorrect answers",
          "In-depth explanations",
          "Immediate feedback to improve retention"
        ],
        "image": "/assets/images/screenshots/7.png"
      },
      {
        "id": 8,
        "title": "Learn from Community Insights",
        "description": "See how other learners performed on each question and measure your knowledge against the community.",
        "features": [
          "Community score for each question",
          "Percentage range of correct responses",
          "Benchmark your performance"
        ],
        "image": "/assets/images/screenshots/8.png"
      },
      {
        "id": 9,
        "title": "Master Concepts with Flashcards",
        "description": "Reinforce your knowledge using interactive flashcards designed to help you recall definitions and key concepts effortlessly.",
        "features": [
          "Simple question-answer format",
          "Terminology with definitions",
          "Supports quick self-testing"
        ],
        "image": "/assets/images/screenshots/9.png"
      },
      {
        "id": 10,
        "title": "Track Key Terms Easily",
        "description": "Quickly find and understand important certification terms with our searchable glossary for fast and effective learning.",
        "features": [
          "Alphabetical search for terms",
          "Clear, concise definitions",
          "Expandable sections for detailed explanations"
        ],
        "image": "/assets/images/screenshots/10.png"
      }
    ]
  },

  certificationData: {
    title: 'CompTIA Certifications',
    subtitle: 'Industry-leading IT certifications',
    items: [
      {
        title: 'CompTIA Security+ SY0-701',
        domains: [
          'General Security Concepts',
          'Threats, Vulnerabilities, and Mitigations',
          'Security Architecture',
          'Security Operations',
          'Security Program Management'
        ],
        requirements: [
          'Network+ certification recommended',
          '2 years of IT experience recommended',
          'Pass the Security+ exam'
        ],
        experience: 'Recommended 2 years of experience in IT with a security focus',
        benefits: [
          'Global recognition',
          'Career advancement',
          'Higher salary potential',
          'DoD 8570 compliance'
        ],
        exam: {
          duration: '90 minutes',
          questions: 'Maximum of 90 questions',
          passingScore: '750 out of 900'
        }
      }
    ]
  },



  contactData: {
    title: 'Contact Us',
    subtitle: 'Have questions? We\'re here to help'
  },

  footerData: {
    logo: '/assets/images/logo.png',
    description: 'Your trusted partner for CompTIA certification exam preparation',
    socialLinks: [{
      url: 'https://www.linkedin.com/company/learnzapp',
      icon: '/assets/images/linkedin-icon.png'
    }],
    examLinksTitle: 'LearnZapp Exam Prep Apps',
    examLinks: [
      {
        name: 'ISC2 Official App',
        details: 'CISSP, CCSP and SSCP',
        icon: '/assets/images/app-icons/isc2.png',
        url: 'https://isc2.learnzapp.com'
      },
      {
        name: 'ISACA Official App',
        details: 'CISA and CISM',
        icon: '/assets/images/app-icons/isaca.png',
        url: 'https://isaca.learnzapp.com'
      },
      {
        name: 'CompTIA Certifications',
        details: '12 CompTIA Exams',
        icon: '/assets/images/app-icons/comptia.png',
        url: 'https://comptia.learnzapp.com'
      }
    ],
    copyright: '© 2024 LearnZapp. All rights reserved.',
    footerLinks: [
      { name: 'Privacy Policy', url: '#' },
      { name: 'Terms of Service', url: '#' },
      { name: 'Contact', url: '#' },
      { name: 'Support', url: '#' }
    ]
  },

  keyStats: {
    items: [
      {
        number: '10000',
        label: 'Study Questions'
      },
      {
        number: '3000',
        label: 'Study Articles'
      },
      {
        number: '5000',
        label: 'Flashcards'
      }
    ]
  },

  faqData: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about our certification preparation platform',
    faqs: [
      {
        question: 'What certifications do you support?',
        answer: 'We support 12 CompTIA certifications: A+ (220-1201 & 220-1202), Network+ (N10-009), Security+ (SY0-701), Cloud+ (CV0-004), Linux+ (XK0-006), Server+ (SK0-005), CySA+ (CS0-003), PenTest+ (PT0-003), Project+ (PK0-005), DataSys+ (DS0-001), and DataX (DX0-001).'
      },
      {
        question: 'How does the adaptive learning system work?',
        answer: 'Our adaptive learning system analyzes your performance across different domains and topics, identifying your strengths and areas for improvement. It then customizes your study plan, focusing on topics where you need more practice while reinforcing your strong areas.'
      },
      {
        question: 'Can I access the platform on multiple devices?',
        answer: 'Yes! Our platform is available on web browsers, iOS, and Android devices. Your progress automatically syncs across all devices, allowing you to study seamlessly whether you\'re at home or on the go.'
      },
      {
        question: 'What\'s included in the subscription plans?',
        answer: 'All subscription plans include access to our complete question bank for all 12 CompTIA exams, study materials, analytics dashboard, and practice tests. Longer-term plans offer additional savings and may include premium features like detailed performance analytics and personalized study recommendations.'
      },
      {
        question: 'How often is the content updated?',
        answer: 'We regularly update our content to align with the latest exam changes and industry best practices. Our team of certified professionals reviews and updates questions and study materials to ensure they reflect current exam requirements and industry standards.'
      },
      {
        question: 'Do you offer a money-back guarantee?',
        answer: 'Yes, we offer a 7-day money-back guarantee for our subscription plans. If you\'re not satisfied with our platform, you can request a full refund within the first 7 days of your subscription.'
      }
    ]
  }
};
